import { Constant } from "../../Constant";

const attachment = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.CLEAR_ATTACHMENT:
            return {};
        case Constant.action.ADD_ATTACHMENT:
            return { ...state, ...payload };
        case Constant.action.DELETE_ATTACHMENT_DONE:
            var newState = Object.keys(state).reduce((attachments, fileId) => {
                if (fileId != payload.fileId) {
                    attachments[fileId] = state[fileId];
                }
                return attachments;
            }, {});
            return newState;
        default:
            return state;
    }
};

export default attachment;
